<template>
    <div class="card rounded-[5px] w-full h-full">
        <p class="text-[21px] font-semibold m-0 p-0 text-center">Select your target location</p>
        <!-- Dropdowns for Country, City, and District -->
        <!-- <div class="w-full">
                    <label for="country" class="block mb-2 text-sm font-medium">Country*</label>
                    <select v-model="selectedCountry" @change="onCountryChange" class="block w-full p-2 border rounded focus:outline-primary focus:bg-white" :disabled="isAwareness">
                        <option value="" disabled>Select Country</option>
                        <option v-for="country in countries" :key="country.id" :value="country" >
                            {{ country.name_en }}
                        </option>
                    </select>
            </div> -->
        <div class="w-full">
            <label for="Country" class="block mb-2 text-sm font-medium">Country *</label>
            <v-select v-model="selectedCountry" :options="countries" label="name_en" multiple
                class="block w-full border rounded focus:outline-primary focus:bg-white"

            />
        </div>
        <!-- <div class="flex items-center p-0">
            <input type="checkbox" id="selectAllCountries" @change="selectAllCountries" class="styled-checkbox">
            <label for="selectAllCountries" class="ml-1 text-sm font-medium text-black m-0 mt-1">Select All
                Countries</label>
        </div> -->
        <div class="flex justify-between items-center mt-1">
            <p v-if="countriesTouched" class="text-[16px] font-normal text-[#D73823]">Please select one Country at least.</p>
        </div>
        <div class="flex gap-4" v-if="$store.state.step_one.advertisingGoal === 'Conversions'">
            <!-- Cities Column -->
            <div class="w-1/2">
                <label for="Cities" class="block mb-2 text-sm font-medium">Cities *</label>
                <v-select v-model="selectedCity" :options="cities" label="name_en" multiple
                    class="block w-full border rounded focus:outline-primary focus:bg-white"
                    :disabled="selectedCountry.length === 0" />
                <!-- Select All Cities Checkbox (Moved Here) -->
                <div class="flex items-center mt-2" v-if="selectedCountry.length > 0">
                    <input type="checkbox" id="selectAllCities" :disabled="selectedCountry.length === 0" @change="selectAllCities" class="styled-checkbox">
                    <label for="selectAllCities"
                        class="ml-1 text-sm font-medium leading-6 text-black m-0">Select All Cities</label>
                </div>
                <!-- Validation Message -->
                 <p v-if="citiesTouched" class="text-[16px] font-normal text-[#D73823] mt-1">Please select one City at least.</p>
            </div>

            <!-- Districts Column -->
            <div class="w-1/2">
                <label for="District" class="block mb-2 text-sm font-medium">District*</label>
                <v-select v-model="selectedDistrict" :options="filteredDistrictOptions" label="name_en" @input="onDistrictChange"
                    multiple class="block w-full border rounded focus:outline-primary focus:bg-white"
                    :disabled="selectedCity.length === 0"
                >
                </v-select>
                <!-- Select All Districts Checkbox (Moved Here) -->
                <div class="flex items-center mt-2" v-if="selectedCity.length > 0">
                    <input type="checkbox" id="selectAllDistricts" @change="selectAllDistricts"
                        :disabled="selectedCity.length === 0"
                        class="styled-checkbox">
                    <label for="selectAllDistricts" class="ml-1 text-sm font-medium text-black m-0">
                         {{ selectAllDistrictsLabel }}
                    </label>
                </div>
                <!-- Validation Message -->
                <p v-if="validateMarker" class="text-[16px] font-normal text-[#D73823] mt-1">Please select one District at least.</p>
            </div>
        </div>

        <!-- Map -->
        <div class="mt-4">
            <div id="map" class="h-64 w-full bg-gray-200"></div>
        </div>

        <!-- Next and Back Buttons -->
        <div class="flex gap-2 flex-row-reverse mt-4">
            <button class="bg-primary p-2 px-[66px] rounded-[5px] text-white" @click="next()"
                v-if="$store.state.step < 4">Next</button>
            <button class="bg-white p-2 px-[66px] rounded-[5px] text-primary border-2 border-primary" @click="back()"
                v-if="$store.state.step > 1">Back</button>
        </div>
    </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";
import vSelect from "vue-select";
import axios from 'axios';
import { mapState, mapGetters, mapMutations } from "vuex";


export default {
    components: { vSelect },
    data() {
        return {
            countries: [],
            cities: [],
            districts: [],

            selectedCountry: [],
            selectedCity: [],
            selectedDistrict: [],
            map: null,
            currentPolygons: new Set(),
            validateMarker: false,
            citiesTouched: false,
            countriesTouched: false,
            isSelectAllDistricts: false,
            isSelectAllCountries: false,
            isSelectAllCities: false,
        };
    },
    watch: {
        isAwareness(newVal) {
            if (newVal) {
                this.selectedCountry = this.countries.find(country => country.name_en === 'Saudi Arabia');
                this.drawSaudiArabiaPolygon();
            }
        },
        async selectedCountry(newVal, oldVal) {
            console.log('this.selectedCountry newVal', newVal);

            // --- Logic to handle multiple selected countries ---
            let allFetchedCities = [];
            const existingSelectedCityIds = new Set(this.selectedCity.map(c => c.id));

            if (newVal.length === 0) {
                // Clear everything if no country is selected
                this.cities = [];
                this.selectedCity = [];
                this.districts = [];
                this.selectedDistrict = [];
                // Reset checkboxes if needed (omitted for brevity)
            } else {
                // Fetch cities for all selected countries
                const cityFetchPromises = newVal.map(async (country) => {
                    try {
                        const citiesResponse = await axios.get(`https://geoservice-staging.dkilo.net/api/countries/${country.id}/cities/`);
                        if (citiesResponse.data.success && citiesResponse.data.data.cities) {
                            // Add country_id to each city object
                            return citiesResponse.data.data.cities.map(city => ({
                                ...city,
                                country_id: country.id // Add the country ID here
                            }));
                        } else {
                            console.error(`Failed to fetch cities for country ${country.id}`);
                            return []; // Return empty array on failure
                        }
                    } catch (error) {
                        console.error(`Error fetching cities for country ${country.id}:`, error);
                        return []; // Return empty array on error
                    }
                });

                // Wait for all fetches to complete
                const results = await Promise.all(cityFetchPromises);
                allFetchedCities = results.flat(); // Combine results from all countries

                this.cities = allFetchedCities; // Update the options for the city dropdown

                // Filter selectedCity: Keep only those whose country is still in newVal
                const selectedCountryIds = new Set(newVal.map(c => c.id));
                this.selectedCity = this.selectedCity.filter(city =>
                    // Ensure city has country_id (might be missing if loaded from old state)
                    // or if it was selected before this change, check if its ID matches any *newly* fetched city
                    (city.country_id && selectedCountryIds.has(city.country_id)) ||
                    allFetchedCities.some(fetchedCity => fetchedCity.id === city.id)
                );
            }
            // --- End multi-country logic ---
        },
        async selectedCity(newVal) {
            console.log('new cities: ',newVal);
            this.districts = [];
            if (newVal.length === 0) {
                this.selectedDistrict = [];
                const allCitiesCheckbox = document.getElementById("selectAllCities");
                if (allCitiesCheckbox) {
                    allCitiesCheckbox.checked = false;
                    this.isSelectAllCities = false;
                }
            }
            for (const city of newVal) {
                const districtsResponse = await axios.get(`https://geoservice-staging.dkilo.net/api/cities/${city.id}/districts/`);
                // Add city_id to each fetched district
                const districtsWithCityId = districtsResponse.data.data.districts.map(district => ({
                    ...district,
                    city_id: city.id // Manually add the city_id
                }));
                this.districts = [...this.districts, ...districtsWithCityId];
            }
            // Filter selectedDistrict to keep only those whose city is still selected
            this.selectedDistrict = this.selectedDistrict.filter(district => {
                // Keep placeholders if their city is still selected
                if (district.isSelectAllPlaceholder) {
                    return newVal.some(city => city.id === district.cityId);
                }
                // Keep individual districts if their city is still selected
                return newVal.some(city => this.districts.find(d => d.id === district.id)?.city_id === city.id);
            });
        },
        selectedDistrict(newSelectedDistricts, oldSelectedDistricts) {
            const added = newSelectedDistricts.filter(d => !oldSelectedDistricts.some(old => old.id === d.id));
            const removed = oldSelectedDistricts.filter(old => !newSelectedDistricts.some(d => d.id === old.id));

            // Handle removals
            removed.forEach(district => {
                if (district.isSelectAllPlaceholder) {
                    // Placeholder removed: Remove all polygons for that city
                    const cityId = district.cityId;
                    this.districts.forEach(d => {
                        if (d.city_id === cityId) {
                            this.removeDistrictPolygon(d.id);
                        }
                    });
                    // Check if any placeholders are left
                    const remainingPlaceholders = newSelectedDistricts.filter(d => d.isSelectAllPlaceholder);
                    if (remainingPlaceholders.length === 0) {
                        this.isSelectAllDistricts = false;
                        const checkbox = document.getElementById("selectAllDistricts");
                        if (checkbox) checkbox.checked = false;
                    }
                } else {
                    // Individual district removed
                    this.removeDistrictPolygon(district.id);
                }
            });

            // Handle additions
            added.forEach(district => {
                if (!district.isSelectAllPlaceholder) {
                     // Individual district added: Remove placeholder if it exists for the same city
                    const cityId = district.city_id;
                    const placeholderIndex = newSelectedDistricts.findIndex(d => d.isSelectAllPlaceholder && d.cityId === cityId);

                    if (placeholderIndex > -1) {
                        // Temporarily remove placeholder to avoid watcher loop
                        const placeholder = newSelectedDistricts[placeholderIndex];
                        oldSelectedDistricts = oldSelectedDistricts.filter(d => d.id !== placeholder.id);
                        // Remove placeholder from the actual model
                        this.selectedDistrict.splice(placeholderIndex, 1);
                         // Remove all polygons for that city (as we are switching to individual)
                        this.districts.forEach(d => {
                            if (d.city_id === cityId) {
                                this.removeDistrictPolygon(d.id);
                            }
                        });
                    }
                    // Fetch and draw the individual district
                    this.fetchAndDrawDistrict(district);
                }
                // Placeholders are handled by the selectAllDistricts method, no drawing needed here
            });

             // Update checkbox state if all districts are selected manually
            const allActualDistrictsSelected = this.districts.length > 0 && this.districts.every(d => newSelectedDistricts.some(sd => sd.id === d.id));
            if (allActualDistrictsSelected && !this.isSelectAllDistricts) {
                this.isSelectAllDistricts = true;
                 const checkbox = document.getElementById("selectAllDistricts");
                 if (checkbox) checkbox.checked = true;
                // Replace individual districts with placeholder(s)
                 const placeholders = this.selectedCity.map(city => ({
                    id: `all-districts-${city.id}`,
                    name_en: `All districts of ${city.name_en}`,
                    isSelectAllPlaceholder: true,
                    cityId: city.id
                }));
                this.selectedDistrict = placeholders;
            }
        }
    },
    async mounted() {
        await this.fetchCountries();

        // Set default country after fetching
        const defaultCountry = this.countries.find(c => c.name_en === 'Saudi Arabia');
        if (defaultCountry) {
            this.selectedCountry = [defaultCountry];
        }

        // Initialize Google Map
        const loader = new Loader({
            // apiKey: "AIzaSyBg8BVLET0Q-tHhAIgr-rmo3ddQiwgFgCo", // dev key
            apiKey: "AIzaSyCiLDfWO0dPjiiJEUqYWoM_LjUAJQOgyGk", // prod key
            // libraries: ["places", "drawing", "geometry"],

            // old configuration
            version: "weekly",
            libraries: ["visualization"],
        });
        loader.load().then(() => {
            this.map = new google.maps.Map(document.getElementById("map"), {
                center: { lat: 24.7136, lng: 46.6753 },
                zoom: 5,
            });
        });

        // Restore state from Vuex
        const storedState = this.$store.state.step_two;
        if (storedState && storedState.countries && storedState.countries.length > 0) {
            // console.log("[DEBUG] Restoring state from step_two:", JSON.stringify(storedState, null, 2));

            let restoredCountries = [];
            let restoredCities = [];
            let restoredDistricts = [];
            let allStoredDistrictIds = new Set();
            let allPossibleDistrictIdsForStoredCities = new Set();
            let selectAllDetected = false;

            // Pass 1: Extract raw data and check for "Select All"
            storedState.countries.forEach(country => {
                // Find the full country object (should be available after fetchCountries)
                const fullCountry = this.countries.find(c => c.id === country.unifiedId);
                if (fullCountry) {
                    restoredCountries.push(fullCountry);
                    country.cities.forEach(city => {
                        // Temporarily store city data - we'll find full object later
                        restoredCities.push({ id: city.unifiedId, name_en: city.name_en, country_id: country.unifiedId });
                        city.districts.forEach(district => {
                            restoredDistricts.push({ id: district.unifiedId, name_en: district.name_en, city_id: city.unifiedId });
                            allStoredDistrictIds.add(district.unifiedId);
                        });
                    });
                } else {
                     // console.warn(`[DEBUG] Restore: Could not find full country object for ID: ${country.unifiedId}`);
                }
            });

            // Need to know the total districts for the restored cities to detect "Select All"
            // This requires this.districts to be populated, which happens in watchers.
            // We store the raw restored districts first, then check for select all later.

            // --- Assign core selections - this will trigger watchers ---
            this.selectedCountry = restoredCountries;
            this.selectedCity = restoredCities; // Watcher will fetch full city/district data
            this.selectedDistrict = restoredDistricts; // Store raw districts for now

            // --- Defer UI updates and potential "Select All" placeholder logic ---
            this.$nextTick(async () => {
                // console.log("[DEBUG] Restore: $nextTick running. Checking UI updates.");
                try {
                    // Wait briefly OR use a flag to ensure watchers have likely populated data
                    await new Promise(resolve => setTimeout(resolve, 500)); // Small delay heuristic

                    // console.log(`[DEBUG] Restore: After delay, this.districts count: ${this.districts.length}`);

                    // Now check for "Select All" based on potentially populated this.districts
                    const citiesToCheck = this.selectedCity.map(c => c.id);
                    const allPossibleDistricts = this.districts.filter(d => citiesToCheck.includes(d.city_id));
                    allPossibleDistrictIdsForStoredCities = new Set(allPossibleDistricts.map(d => d.id));

                    selectAllDetected = allStoredDistrictIds.size > 0 && allStoredDistrictIds.size === allPossibleDistrictIdsForStoredCities.size;
                    // console.log(`[DEBUG] Restore: Select All Check - Stored: ${allStoredDistrictIds.size}, Possible: ${allPossibleDistrictIdsForStoredCities.size}, Detected: ${selectAllDetected}`);

                    if (selectAllDetected) {
                        this.isSelectAllDistricts = true;
                        // Replace raw districts with placeholders
                        this.selectedDistrict = this.selectedCity.map(city => ({
                            id: `all-districts-${city.id}`,
                            name_en: `All districts of ${city.name_en}`,
                            isSelectAllPlaceholder: true,
                            cityId: city.id
                        }));
                    } else {
                         this.isSelectAllDistricts = false;
                         // Ensure selectedDistrict contains the full objects now potentially available in this.districts
                         this.selectedDistrict = restoredDistricts.map(rd =>
                            this.districts.find(d => d.id === rd.id) || rd // Fallback to raw if full not found
                         ).filter(Boolean); // Remove nulls if find failed
                    }

                    // Update checkboxes
                    const allCitiesCheckbox = document.getElementById("selectAllCities");
                    if (allCitiesCheckbox) {
                        const allPossibleCities = this.cities.filter(c => this.selectedCountry.some(rc => rc.id === c.country_id));
                        this.isSelectAllCities = allPossibleCities.length > 0 && allPossibleCities.length === this.selectedCity.length;
                        allCitiesCheckbox.checked = this.isSelectAllCities;
                    }
                    const allDistrictsCheckbox = document.getElementById("selectAllDistricts");
                    if (allDistrictsCheckbox) {
                        allDistrictsCheckbox.checked = this.isSelectAllDistricts;
                    }

                    // Redraw map
                    this.redrawRestoredPolygons();
                } catch (error) {
                    console.error("[DEBUG] Restore: Error during deferred UI update:", error);
                }
            });

        } else {
            // console.log("[DEBUG] No valid state found in step_two to restore.");
            // Apply default country if no state
            const defaultCountry = this.countries.find(c => c.name_en === 'Saudi Arabia');
            if (defaultCountry) {
                this.selectedCountry = [defaultCountry]; // This will trigger watchers
            }
        }
    },
    computed: {
        isAwareness() {
            return this.$store.state.step_one.advertisingGoal === 'Awareness';
        },
        selectAllDistrictsLabel() {
            const cityCount = this.selectedCity.length;
            if (cityCount === 1) {
                // Assuming selectedCity objects have a 'name_en' property
                return `Select all districts of ${this.selectedCity[0].name_en}`;
            } else if (cityCount > 1) {
                return 'Select all districts of selected cities';
            }
            // No need for length === 0 case, as v-if hides this element
            return ''; // Default empty string
        },
        ...mapGetters(["selectedCountriesState", "selectedCitiesState", "selectedDistrictsState"]),
        // Computed property to filter district options
        filteredDistrictOptions() {
            // Get IDs of cities for which "Select All" is active
            const selectAllCityIds = this.selectedDistrict
                .filter(item => item.isSelectAllPlaceholder)
                .map(item => item.cityId);

            // If no city has "Select All" active, return all available districts
            if (selectAllCityIds.length === 0) {
                return this.districts;
            }

            // Otherwise, filter out districts belonging to cities with "Select All" active
            const filteredList = this.districts.filter(district => !selectAllCityIds.includes(district.city_id));
            return filteredList;
        }
    },
    methods: {
        clearMapDataLayer() {
            this.map.data.forEach(feature => {
                this.map.data.remove(feature); // Remove all features (polygons, etc.)
            });
        },
        clearOrRemovePolygonsOnZoom() {
            Object.keys(this.currentPolygons).forEach(districtId => {
                if (!this.selectedDistrict.includes(districtId)) {
                    this.removeDistrictPolygon(districtId);
                }
            });
        },
        forceRedrawMap() {
            const currentCenter = this.map.getCenter();
            const currentZoom = this.map.getZoom();

            // Temporarily change the zoom and center to force a map redraw
            this.map.setZoom(currentZoom + 1);
            this.map.setCenter({ lat: currentCenter.lat(), lng: currentCenter.lng() });

            setTimeout(() => {
                this.map.setZoom(currentZoom); // Set zoom back to original
                this.map.setCenter(currentCenter); // Reset the center
            }, 100);
        },
        checkAndRemovePolygons() {
            // Check all polygons and ensure removed polygons stay removed


            for (const districtId in this.currentPolygons) {
                if (!this.selectedDistrict.includes(districtId)) {
                    this.removeDistrictPolygon(districtId);
                }
            }
        },
        ensurePolygonsAreCorrect() {
            // Loop through the current polygons and remove any that should no longer exist
            for (const districtId in this.currentPolygons) {
                if (!this.selectedDistrict.includes(districtId)) {
                    this.removeDistrictPolygon(districtId);
                }
            }
        },
        ...mapMutations([
            "setSelectedCountries",
            "setSelectedCities",
            "setSelectedDistricts",
        ]),
        async fetchCountries() {
            try {
                const response = await axios.get('https://geoservice-staging.dkilo.net/api/geocodes', {
                    headers: {
                        // Authorization:`Berear ${localStorage.getItem("token")}`,
                    }
                });
                const base64EncodedBody = response.data.data;

                if (response.data.success) {
                    this.countries = response.data.data;
                    console.log('this.countries', this.countries);
                } else {
                    console.error("Error: API returned unsuccessful response");
                }
            } catch (error) {
                console.error("Error fetching countries:", error);
            }
        },
        onCityChange() {
            this.selectedDistrict = [];
        },
        onDistrictChange(newSelectedDistricts) {
            const oldSelectedDistricts = this.selectedDistrict || [];


            // Update the selected districts
            this.selectedDistrict = newSelectedDistricts;

            // Handle removing polygons for districts that are no longer selected
            const removedDistricts = oldSelectedDistricts.filter(district => !newSelectedDistricts.includes(district));
            const addedDistricts = newSelectedDistricts.filter(district => !oldSelectedDistricts.includes(district));

            removedDistricts.forEach(this.removeDistrictPolygon);
            addedDistricts.forEach(this.fetchAndDrawDistrict);  // Fetch and draw newly selected districts

            this.fitMapToPolygons();
        },
        selectAllDistricts() {
            this.isSelectAllDistricts = !this.isSelectAllDistricts;
            if (this.isSelectAllDistricts) {
                // Create placeholder objects for each selected city
                const placeholders = this.selectedCity.map(city => ({
                    id: `all-districts-${city.id}`, // Unique ID for placeholder
                    name_en: `All districts of ${city.name_en}`, // Display label
                    isSelectAllPlaceholder: true,
                    cityId: city.id
                }));
                this.selectedDistrict = placeholders;

                // Draw all polygons for the actual districts
                this.districts.forEach(district => {
                     // Check if district belongs to any selected city before drawing
                    if (this.selectedCity.some(city => district.city_id === city.id)) {
                         this.fetchAndDrawDistrict(district);
                    }
                });

            } else {
                 // Clear selections and remove polygons
                const cityIdsToClear = this.selectedCity.map(city => city.id);
                this.selectedDistrict = [];
                this.districts.forEach(district => {
                    if (cityIdsToClear.includes(district.city_id)) {
                        this.removeDistrictPolygon(district.id);
                    }
                });
            }
        },
        selectAllCountries() {
            this.isSelectAllCountries = !this.isSelectAllCountries;
            if (this.isSelectAllCountries) {
                this.selectedCountry = this.countries;
            } else {
                this.selectedCountry = [];
                this.isSelectAllCities = false;
                const allCitiesCheckbox = document.getElementById("selectAllCities");
                if (allCitiesCheckbox) {
                    allCitiesCheckbox.checked = false;
                    this.isSelectAllCities = false;
                }
                const allDistrictsCheckbox = document.getElementById("selectAllDistricts");
                if (allDistrictsCheckbox) {
                    allDistrictsCheckbox.checked = false;
                    this.isSelectAllDistricts = false;
                }
            }
        },
        selectAllCities() {
            this.isSelectAllCities = !this.isSelectAllCities;
            if (this.isSelectAllCities) {
                this.selectedCity = this.cities;
            } else {
                this.selectedCity = [];
                const allDistrictsCheckbox = document.getElementById("selectAllDistricts");
                if (allDistrictsCheckbox) {
                    allDistrictsCheckbox.checked = false;
                    this.isSelectAllDistricts = false;
                }
            }
        },
        fitMapToPolygons() {
            if (!this.map || Object.keys(this.currentPolygons).length === 0) {
                console.warn("No polygons to fit to the map.");
                return;
            }
            const bounds = new google.maps.LatLngBounds();

            Object.values(this.currentPolygons).forEach(polygon => {
                polygon.getPath().forEach(point => {
                    bounds.extend(point);
                });
            });

            this.map.fitBounds(bounds);
        },

        fetchAndDrawDistrict(district) {
            if(district.geometry)
                this.drawDistrictOnMap(district.geometry.coordinates[0], district.id);
        },
        drawDistrictOnMap(geometry, districtId) {
            // if (!this.map) {
            //     console.error("Map is not initialized");
            //     return;
            // }
            // If a polygon for this district already exists, remove it
            if (this.currentPolygons[districtId]) {
                this.currentPolygons[districtId].setMap(null);
            }

            // Convert geometry to Google Maps LatLng objects
            const latLngs = geometry[0].map(coord => ({ lat: coord[1], lng: coord[0] }));
            // Create a new polygon
            const polygon = new google.maps.Polygon({
                paths: latLngs,
                strokeColor: '#369da3',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#369da3',
                fillOpacity: 0.35,
            });

            // Add polygon to the map
            polygon.setMap(this.map);

            // Track the polygon
            this.currentPolygons[districtId] = polygon;

            // Adjust the map view to fit the polygon
            const bounds = new google.maps.LatLngBounds();
            latLngs.forEach(latlng => {
                bounds.extend(latlng);
            });
            this.map.fitBounds(bounds);
            // Store the polygon for later reference (to remove it when needed)
            this.currentPolygons[districtId] = polygon;
        },
        async drawSaudiArabiaPolygon() {
            // Fetch district geometry and draw it on the map
            try {
                const response = await axios.get(`https://geoservice-staging.dkilo.net/api/countries/1`, {
                    headers: {
                        Authorization: `Berear ${localStorage.getItem("token")}`,
                    }
                });

                // Check if the decoded response was successful
                if (response.data.success) {
                    const geometry = response.data.data.country.geometry.coordinates;;
                    this.selectedCountry = [1];
                    this.drawDistrictOnMap(geometry);
                } else {
                    console.error("Error: API returned unsuccessful response");
                }
            } catch (error) {
                console.error("Error fetching district geometry:", error);
            }
        },
        // removeDistrictPolygon(districtId) {
        // const polygonIndex = Object.keys(this.currentPolygons).findIndex(key => key === districtId);
        // const polygon = this.currentPolygons.get(districtId);
        //     if (polygon) {
        //     this.currentPolygons.delete(polygon);
        //     polygon.setMap(null);
        //     polygon.setPaths([]);
        //     }
        // },
        removeDistrictPolygon(districtId) {
            if (this.currentPolygons[districtId]) {
                // Remove the polygon from the map
                this.currentPolygons[districtId].setMap(null);

                google.maps.event.clearInstanceListeners(this.currentPolygons[districtId]);

                // Delete the reference to the polygon
                delete this.currentPolygons[districtId];
                this.map.data.forEach((feature) => {
                    this.map.data.remove(feature);
                    // Remove polygon from any layers, overlays, or maps it's associated with
                    if (this.currentPolygons[districtId]) {
                        this.currentPolygons[districtId].setMap(null);  // Remove from the map
                    }

                    // Clear data layers if using Google Maps Data API
                    if (this.map.data) {
                        this.map.data.remove(this.currentPolygons[districtId]);
                    }
                });
            } else {
                console.log(`Polygon for district ${districtId} not found.`);
            }
        },
        validateFormConversion(){
            if(this.selectedCountry.length < 1) {
                this.countriesTouched = true;
                return false;
            } else {
                this.countriesTouched = false;
            }
            if(this.selectedCity.length < 1){
               this.citiesTouched = true;
               return false;
            } else {
                this.citiesTouched = false;
            }
            if(this.selectedDistrict.length < 1){
               this.validateMarker = true;
               return false;
            } else {
                this.validateMarker = false;
            }
            return true;
        },
        validateFormAwareness(){
            if(this.selectedCountry.length < 1) {
                this.countriesTouched = true;
                return false;
            } else {
                this.countriesTouched = false;
            }
            return true;
        },
        next() {
            if (this.isAwareness) {
                // Handle Awareness Logic
                if (!this.validateFormAwareness()) {
                    window.scrollTo(0, 0);
                } else {
                    const mappedCountries = this.selectedCountry.map(country =>
                        ({ unifiedId: country.id, name_en: country.name_en })
                    );
                    this.setSelectedCountries(this.selectedCountry);
                    const locationObject = { countries: mappedCountries };
                    this.$store.commit("updataStepTwo", locationObject);
                    if (this.$store.state.step < 4) {
                        this.$store.state.step = this.$store.state.step + 1;
                        window.scrollTo(0, 0);
                    }
                }
            } else {
                // Handle Conversion Logic
                if (!this.validateFormConversion()) {
                    window.scrollTo(0, 0);
                } else {
                    this.setSelectedCountries(this.selectedCountry);
                    this.setSelectedCities(this.selectedCity);
                    this.setSelectedDistricts(this.selectedDistrict);

                    // Prepare the actual list of districts for the payload
                    let actualSelectedDistricts = [];
                    this.selectedDistrict.forEach(item => {
                        if (item.isSelectAllPlaceholder) {
                            const cityId = item.cityId;
                            const districtsForCity = this.districts.filter(d => {
                                return d.city_id === cityId;
                            });
                            try {
                                actualSelectedDistricts.push(...districtsForCity);
                            } catch (e) {
                                console.error('[DEBUG] Loop: Error during push/spread:', e);
                                console.error('[DEBUG] Loop: districtsForCity:', JSON.stringify(districtsForCity));
                            }
                        } else {
                            actualSelectedDistricts.push(item);
                        }
                    });
                    // Remove duplicates just in case
                    try {
                        actualSelectedDistricts = [...new Map(actualSelectedDistricts.map(item => [item.id, item])).values()];
                    } catch (e) {
                        console.error('[DEBUG] Error during deduplication:', e);
                    }

                    // --- Refactored Mapping Logic Start ---
                    const finalCountries = this.selectedCountry.map(country => {
                        // Find cities selected within this country
                        // Ensure city objects in this.selectedCity have country_id
                        const citiesForThisCountry = this.selectedCity
                            .filter(city => city.country_id === country.id) // Filter selected cities by country ID
                            .map(city => {
                                // Find the actual districts for this specific city from the expanded list
                                const districtsForThisCity = actualSelectedDistricts
                                    .filter(district => district.city_id === city.id) // Filter expanded districts by city ID
                                    .map(district => ({ unifiedId: district.id, name_en: district.name_en })); // Map to final format
                                return { unifiedId: city.id, name_en: city.name_en, districts: districtsForThisCity };
                            });
                        return { unifiedId: country.id, name_en: country.name_en, cities: citiesForThisCountry };
                    });

                    const locationObject = { countries: finalCountries };
                    // --- Refactored Mapping Logic End ---

                    this.$store.commit("updataStepTwo", locationObject);
                    if (this.$store.state.step < 4) {
                        this.$store.state.step = this.$store.state.step + 1;
                        window.scrollTo(0, 0);
                    }
                }
            }

        },
        back() {
            if (this.$store.state.step > 1) {
                this.$store.state.step = this.$store.state.step - 1;
            }
            window.scrollTo(0, 0);
        },
        redrawRestoredPolygons() {
            this.clearMapDataLayer(); // Clear existing polygons if any
            this.currentPolygons = {}; // Reset tracking

            if (this.isSelectAllDistricts) {
                 // Draw all districts for the selected cities
                const cityIds = this.selectedCity.map(c => c.id);
                this.districts.forEach(district => {
                    if (cityIds.includes(district.city_id)) {
                        this.fetchAndDrawDistrict(district);
                    }
                });
            } else {
                // Draw only the individually selected districts
                this.selectedDistrict.forEach(district => {
                    // Find the full district object if needed (might already be full)
                    const fullDistrict = this.districts.find(d => d.id === district.id);
                    if (fullDistrict) {
                         this.fetchAndDrawDistrict(fullDistrict);
                    } else if (district.geometry) { // If the stored object somehow has geometry
                         this.fetchAndDrawDistrict(district);
                    }
                });
            }
            this.fitMapToPolygons();
        },
    }
};
</script>
<style>
#map {
    height: 450px;
}
</style>
